import { Link } from 'react-router-dom'
import styled from 'styled-components'

import { buttonStyles } from 'components/Button/styles'
import { FillViewport } from 'components/FillViewport'
import { AppLayout } from 'layouts/AppLayout'
import { AppPage } from 'layouts/AppPage'
import { useTranslation } from 'utils/translation'

const LinkElement = styled(Link)`
  ${buttonStyles}
`

export const FourOhFour = () => {
  const { t } = useTranslation()
  return (
    <AppLayout>
      <FillViewport>
        <AppPage>
          <div className="fourOhFour">
            <div>
              <h2 className="">{t('not-found.title')}</h2>
              <p>{t('not-found.description')} </p>
              <LinkElement to="/">{t('not-found.redirect')}</LinkElement>
            </div>
          </div>
        </AppPage>
      </FillViewport>
    </AppLayout>
  )
}

export default FourOhFour
